<div class="relative">
    <corp-control-title [corp-title]="corpLabel" [corp-size]="corpSize" [corp-disabled]="disabled"></corp-control-title>
    <input
        class="corp-control pr-8"
        [ngClass]="[
            'corp-control-' + corpSize,
            (ngControl.invalid && (ngControl.touched || ngControl.dirty)) ? 'border-red-500' : ''
        ]"

        [type]="'text'"
        [value]="value"
        [readonly]="corpReadonly"
        [disabled]="disabled || corpLoading"
        (input)="onInput($event)"
        (blur)="onBlur($event)"
    />

        @if(corpLoading) {
            <corp-spinner
                class="absolute right-2 top-1/2 -translate-y-1/2"
                [active]="true"
                color="text-primary-500"
                size="sm"
                [percentArc]="0.5">
            </corp-spinner>
        }

        @if(corpIcon) {
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pt-2 pl-1">

            </div>
        }
        @if(corpSuffix && !corpLoading) {
            <div class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
                <!-- <span class="text-gray-400 text-xs">|</span> -->

                <span class="text-sm font-medium text-gray-600 ">
                {{corpSuffix}}
                </span>
            </div>
        }
</div>